import { createFaasProcedureConfig } from '@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig';
import withOriginServerHeader from './withOriginServerHeaders';
import withExpandedError from './withExpandedErrors';

// https://explorer.aexp.com/functions/ReadCustomerProductDetails.v1
const baseConfig = createFaasProcedureConfig(
  'ReadCustomerProductDetails.v1',
  ({ headers, ...args }) => ({
    ...headers ? { headers } : {},
    body: JSON.stringify(args),
  })
);

export default withExpandedError(withOriginServerHeader(baseConfig));
